export const communityData = [
    {
        imageUrl:"community/community-forums.jpg",
        title:"Forums",
        description:"Consult this vast archive of knowledge about the Unity ecosystem for insight and support. You can find out the latest developments, submit feedback and engage with the developers of Unity.",
        buttonTitle:"Go to Forums",
    },
    {
        imageUrl:"community/unity-blog.webp",
        title:"Blog",
        description:"Get the latest Unity news and information right from the source. Discover what's happening within the Unity ecosystem here first.",
        buttonTitle:"Go to Blog",
    },
    {
        imageUrl:"community/community-answers.jpg",
        title:"Answers",
        description:"Any questions? Beginners and experts alike are welcome to post, so you can help each other out with Unity. The built-in voting system helps you find the best answers faster.",
        buttonTitle:"Go to Answers",
    },
    {
        imageUrl:"community/unity-live-help.jpg",
        title:"Unity Live Help",
        description:"Get 1:1 guidance on any Unity topic or help troubleshooting your project from a verified community expert.",
        buttonTitle:"Go to Unity Live Help",
    },
    {
        imageUrl:"community/community-issuetracker.jpg",
        title:"Issue Tracker",
        description:"Get clear information about the status of bugs that have been successfully reproduced. Plus, vote for the bugs that are most detrimental to your workflow to get it fixed more quickly.",
        buttonTitle:"Go to Issue Tracker",
    },
    {
        imageUrl:"community/unity-documentation.jpg",
        title:"Documentation",
        description:"Unity provides high-quality resources to help you develop interactive content. Our thorough, well-organized and easy-to-read documentation covers how to use every single component in Unity, with a separate reference guide for how to create and use scripts.",
        buttonTitle:"Go to Documentation",
    },
]